module.exports = __webpack_public_path__ + "media/bootstrap-icons/calculator-14875e1c.svg";